export const COLD_START_RETRY_INTERVAL_MS = 10000;
export const COLD_START_MAX_RETRIES = 12;
